// @react/hooks/useSecretSecretEngine.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { secretSecretEngineStore } from '@core/stores';

/**
 * React hook for SecretEngine operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useSecretSecretEngine } from '@react/hooks';
 *
 * const SecretEngineList = observer(() => {
 *   const store = useSecretSecretEngine();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useSecretSecretEngine() {
  return secretSecretEngineStore;
}
